import { http } from "./httpServices";
import { OUTLET, PROMO } from "./constants";

export function fetchAllPromos(params: any) {
  let { page = 1, limit = 10, search = "", isActive = "" } = params;
  return http.get(`${PROMO}`, {
    params: {
      page,
      limit,
      search,
      isActive,
    },
  });
}

export function fetchPromoFromId(id: any) {
  return http.get(`${PROMO}/${id}`);
}

export function addPromo(data: any) {
  return http.post(`${PROMO}`, data);
}

export function updatePromo(data: any, id: any) {
  return http.put(`${PROMO}/${id}`, data);
}
